export type WorkspaceAgentFilterListOption = {
  index: number;
  label: string;
};

/** Options keep their original index, so picks survive filtering. */
export const toWorkspaceAgentFilterListOptions = (labels: readonly string[]): WorkspaceAgentFilterListOption[] =>
  labels.map((label, index) => ({ index, label }));
